<template> 
  <div class="bet-list-mobile card fixed bottom-8 left-4 right-4 z-[1] animate-slide-y-reverse md:hidden">
    <div class="card-text flex items-center justify-between gap-1 py-2">
      <div class="flex items-center gap-1">
        <svg
          data-v-aee14c88=""
          xmlns="http://www.w3.org/2000/svg"
          fill="none"
          viewBox="0 0 24 24"
          stroke-width="1.5"
          stroke="currentColor"
          aria-hidden="true"
        ><path
          stroke-linecap="round"
          stroke-linejoin="round"
          d="M8.25 6.75h12M8.25 12h12m-12 5.25h12M3.75 6.75h.007v.008H3.75V6.75zm.375 0a.375.375 0 11-.75 0 .375.375 0 01.75 0zM3.75 12h.007v.008H3.75V12zm.375 0a.375.375 0 11-.75 0 .375.375 0 01.75 0zm-.375 5.25h.007v.008H3.75v-.008zm.375 0a.375.375 0 11-.75 0 .375.375 0 01.75 0z"
        ></path></svg> รายการแทง <div class="chip min-w-[2rem] gap-1 overflow-hidden rounded-full border border-primary">
          <span class="bet-count animate-slide-left font-semibold"> {{ userSelect.length }}</span>
        </div>
      </div><button
        id="buy-list-dialog-btn"
        class="h-10 text-lg"
        type="button"
        :disabled="!userSelect.length"
        @click="onConfirm"
      >
        <div class="flex items-center justify-center">
          ส่งโพย
        </div>
      </button>
    </div>
  </div>
</template>
<script>

export default { 
  components: {
  },
  props:{
    numberConditions:{
      type:Array,
      default:()=>{
        return[]
      }
    },
    userSelect:{
      type:Array,
      default:()=>{
        return[]
      },
    },
  },
  data () {
    return { 
    }
  }, 
  computed : {
  },
  watch: {

  },
  methods: {
    onConfirm () {
      this.$emit('confirm')
    }
  },  
}
</script>
<style scoped>
.bet-list-mobile {
  background-image: linear-gradient(to top right, var(--bg-primary-400), var(--bg-primary-550));
  z-index: 3;
}

.animate-slide-y-reverse {
  animation: slide-y-reverse .3s ease-in-out 1 !important;
}

.card {
  background-color: #fff;
  border: 1px solid #fff;
  border-radius: .5rem;
  box-shadow: 0 10px 15px -3px rgba(0, 0, 0, .1), 0 4px 6px -4px rgba(0, 0, 0, .1);
  height: auto;
  border-style: none;
}

.card .card-text {
  color: #374151;
  padding: .75rem;
}

.chip {
  align-items: center;
  background-color: var(--bg-secondary-color-v2);
  color: #fff;
  font-size: .875rem;
  justify-content: center;
  line-height: 1.25rem;
  padding: .1rem .5rem;
  white-space: nowrap;
  width: -moz-fit-content;
  width: fit-content;
  text-align: center;
}

.min-w-\[2rem\] {
  min-width: 2rem !important;
}

.animate-slide-left {
  animation: slide-left .3s ease-in-out 1 !important;
}

.bet-list-mobile #buy-list-dialog-btn {
  border-width: 1px;
  border-style: solid;
  --tw-border-opacity: 1;
  border-color: rgb(0 0 0 / var(--tw-border-opacity));
  background-image: linear-gradient(to top right, var(--bg-btn-primary-300), var(--bg-btn-primary-550));
  color: rgb(0 0 0 / var(--tw-text-opacity));
  font-weight: bold;
}

svg {
  height: 1.25rem;
  width: 1.25rem;
}

.btn, [type=button], [type=submit], button {
  align-items: center;
  border-radius: .375rem;
  box-sizing: border-box;
  color: #fff;
  cursor: pointer;
  display: inline-flex;
  font-size: 1rem;
  font-weight: 500;
  height: auto;
  justify-content: center;
  line-height: 1.5rem;
  padding: .5rem .75rem;
  position: relative;
  touch-action: manipulation;
  transition: all .3s cubic-bezier(.4,0,.2,1);
}

.btn .disabled, .btn:disabled, [type=button] .disabled, [type=button]:disabled, [type=submit] .disabled, [type=submit]:disabled, button .disabled, button:disabled {
  cursor: not-allowed !important;
  opacity: .5;
  pointer-events: none;
}

</style>